import { gql } from '@apollo/client';
import { GROUP_BASE_FIELDS } from '../fragments/group.fragments';
import { COMPANY_BASE_FIELDS } from '../fragments/company.fragments';

export const GET_GROUPS_COMPANIES = gql`
  query GetGroups($input: GetGroupsRequest!) {
    getGroups(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        ...GroupBaseFields
        companies {
          ...CompanyBaseFields
        }
      }
    }
  }
  ${COMPANY_BASE_FIELDS}
  ${GROUP_BASE_FIELDS}
`;
